'use strict';

angular.module('clientDashboardApp').factory('configService', function ($q, $http, $cacheFactory, $rootScope) {

  let defaultCache = $cacheFactory.get('$http');

  return {
    getBrandConfig: (maybeBaseUrl, refresh) => {
      if (refresh === true) {
        defaultCache.remove('/brand/config');
      }

      const baseUrl = maybeBaseUrl ? ("/" + maybeBaseUrl) : ""

      return $http
        .get('/brand/config' + baseUrl, {cache: refresh !== true})
        .then((data) => {
          $rootScope.$broadcast('set:brandConfig', data.data)

          return data.data
        })
    },

    // TODO consolidate differing config editors
    getBrandConfigForAccount: (accountId) => {
      return $http.get('/brand/config/account/' + accountId)
    },
    updateBrandRestrictions: (accountId, restrictions) => {
      return $http.put('/brand/config/account/' + accountId + '/restrictions', restrictions);
    },

    updateBrandUserguides: (accountId, userguides) => {
      return $http.put('/brand/config/account/' + accountId + '/userguides', userguides);
    },

    getEmailConfig: () => {
      return $http.get('/emailConfig');
    },

    saveImage: (imageUrl,imageType,accountId) => {
      let params = {imageUrl,imageType}
      if(accountId) { params.accountId = accountId}
      return $http.post('/image/save', params)
    },
    saveReviewTags: (accountId, tags) => {
      return $http.post('/brand/config/account/' + accountId + '/reviewTag', tags)
    },
    addReviewTag: (accountId, tag) => {
      return $http.post('/brand/config/account/' + accountId + '/reviewTag', tag)
    },
    removeReviewTag: (accountId, catId) => {
      return $http.delete('/brand/config/account/' + accountId + '/reviewTag/' + catId)
    },
    getFullConfig(accountId) {
      return $http.get('/config/' + accountId + '/edit')
    },
    updateFullConfig(accountId, update) {
      return $http.post('/config/' + accountId + '/edit', update)
    },
    isAdviceLocalApiKeyValid(key) {
      return $http.get('/config/isAdviceLocalApiKeyValid/' + key)
    }


  }

});
